import React, { useEffect, useRef } from "react";
import MessageRow from "./components/MessageRow";
import "./index.css";

const MessagesContainer = (props) => {
  const { messages, visitor, searchMsg } = props;
  const messageEnd = useRef();

  useEffect(() => {
    scrollToBottom();
  }, []);

  const scrollToBottom = () => {
    messageEnd.current?.scrollIntoView({ behavior: "smooth" });
  };

  let lastBody = "";
  const filteredMessages = messages?.filter((msg) => {
    const isVisitorLeft = /^Visitor#.* left$/.test(msg.body);
    if (msg?.type === 4) {
      if (msg.body === lastBody) {
        return false; // Skip if it's the same as the last body
      }
    }
    lastBody = msg.body; // Update lastBody
    return true; // Include this message
  });

  return (
    <div className={`msgs_container`}>
      {filteredMessages?.map((message) => (
        <MessageRow
          message={message}
          visitor={visitor}
          key={message.id}
          searchMsg={searchMsg}
        />
      ))}
      <div ref={messageEnd} />
    </div>
  );
};

export default React.memo(MessagesContainer);
